import { memo } from 'react'

import Flex from '../../ui/flex/flex'
import Grid from '../../ui/grid/grid'
import Modal from '../../ui/modal/modal'
import Button from '../../ui/button/button'

import { ISelectDictionary } from './selectDictionary.type'
import { TableBody, TableContainer, TableRow } from '../../ui/table/table'
import Empty from '../../ui/empty/empty'
import imgEmpty from './../../../styles/images/empty.svg'
import Input from '../../ui/input/input'
import { IconClearClose, IconSearch } from '../../../styles/images/icons'
import { Tooltip } from 'react-tooltip'
import Loader from '../../ui/loader/loader'


/** Выбор из справочника */
export default memo(({isOpen, isLoading, headerText, txtSearch, selectedID, commonList, handlerButtonOk, handlerButtonCancel}: ISelectDictionary) => {
    return <Modal isOpen={isOpen} isEsc isWrapper onCancel={handlerButtonCancel}>
        <Flex className='modal_container'>
            <Flex className='modal_container-header' direction='row' alignItems='center' justifyContent='space-between'>
                <h4>{headerText || 'Выбор справочника'}</h4>
                <Button id='tooltipClose' size='sm' variant='icon' onClick={handlerButtonCancel}><IconClearClose /></Button>
            </Flex>

            <Flex gap='4px' className='modal_container-body'>
                <Flex gap='6px' className='modal_container-content'>
                    {isLoading && <Loader isOpen={isLoading} backdrop color='#f34e2e' />}

                    <Input size='sm' paddingLeft={4} paddingRight={3} {...txtSearch} 
                        isDisabled={commonList.value.length === 0}
                        placeholder='Поиск по ключевым словам'
                        prefix={<IconSearch width={18} height={18} />}
                        suffix={txtSearch.value && <Button id='toolTipClear' size='xs' variant='icon' onClick={() => txtSearch.setValue('')}><IconClearClose width={18} height={18} /></Button>}
                    />

                    <TableContainer className='dict_container'>
                        <TableBody>
                            {commonList.value.length === 0
                                ? <Empty image={imgEmpty} size='50px' />
                                : commonList.value.filter((val) => {
                                    const { name } = val
                                    const searchValue = txtSearch.value ? txtSearch.value.toLowerCase() : ''
            
                                    return (
                                        name.toLowerCase().includes(searchValue)
                                    ) ? val : false
                                }).map((item, index) => (
                                    <TableRow key={index + 1} indexNumber={<span>{selectedID.value === item.id ? '✔' : index + 1}</span>} 
                                        paddingInset='4px 8px' indexNumberWidth="40px" 
                                        classGridTemplateColumns="files_grid_columns" 
                                        onClick={() => selectedID.setValue(item.id)}
                                        backgroundColor={selectedID.value === item.id ? '#F34E2E' : ''}>

                                        <div style={{ textWrap: 'nowrap', overflow: 'hidden' }}>
                                            <p>{item.name}</p>
                                            {item.substring && <p style={{ opacity: '.7' }}>{item.substring}</p>}
                                        </div>
                                    </TableRow>
                                ))
                            }
                        </TableBody>
                    </TableContainer>
                </Flex>

                <Grid gap='6px' gridTemplate='columns' gridTemplateColumns='1fr 1fr'>
                    <Button variant='primaryDark' width='100%' onClick={handlerButtonCancel}>ОТМЕНА</Button>
                    <Button width='100%' onClick={handlerButtonOk}>ВЫБРАТЬ</Button>
                </Grid>
            </Flex>
        </Flex>

        <Tooltip anchorSelect="#toolTipClear" place="left" content='Очистить' style={{ borderRadius: '10px' }} border='2px solid #f34e2e' />
        <Tooltip anchorSelect="#tooltipClose" place="left" content='Закрыть' style={{ borderRadius: '10px' }} border='2px solid #f34e2e' />
    </Modal>
})